import { v4 as uuidv4 } from "uuid";
import { createRichTextProp } from "@/react/components/shared/BuilderUI/DefaultBlocks/utils/richTextHelpers";
import { getBackgroundImageOptions } from "@/react/components/shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import { getTextAlignOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import type {
  BaseBlock,
  BaseProp,
} from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import { defaultData as defaultImageData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/ImgBlockDefaultData";
import placeholderImage from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/ImgBlock/img_preview_large.png";
import { defaultData as defaultLogoData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/LogoBlock/LogoBlockDefaultData";
import { defaultData as defaultPData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P1BlockDefaultData";
import { defaultStyles } from "./defaultStyles";

const content: BaseProp = {
  prop: "children",
  type: "children",
  value: [
    {
      ...defaultLogoData,
      props: {
        ...defaultLogoData.props,
        styles: {
          ...defaultLogoData.props.styles,
          prop: "styles",
          type: "styles",
          value: {
            ...(defaultLogoData.props.styles.value as Record<string, unknown>),
            ...{
              sizing: getSizingOptions({
                defaultValue: {
                  width: "108px",
                  height: "auto",
                  minWidth: "auto",
                  minHeight: "auto",
                  maxWidth: "auto",
                  maxHeight: "auto",
                },
              }),
              margin: getMarginOptions({
                defaultValue: {
                  marginTop: "48",
                  marginBottom: "28",
                  marginLeft: "24",
                  marginRight: "24",
                },
              }),
            },
          },
        },
      },
    },
    {
      ...defaultPData,
      props: {
        ...defaultPData.props,
        text: createRichTextProp("Start adding your content"),
        styles: {
          ...defaultPData.props.styles,
          prop: "styles",
          type: "styles",
          value: {
            ...(defaultPData.props.styles.value as Record<string, unknown>),
            textAlign: getTextAlignOptions("center"),
            margin: getMarginOptions({
              defaultValue: {
                marginTop: "32",
                marginBottom: "40",
                marginLeft: "24",
                marginRight: "24",
              },
            }),
          },
        },
      },
    },
    createImageBlock({
      signedId: "",
      placeholder: placeholderImage,
      baseData: defaultImageData,
    }),
  ],
};

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "defaultBlock",
  props: {
    content,
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        backgroundImage: getBackgroundImageOptions(),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
